import type {MediaAsset,Model} from '../types';
export type Reference={kind:MediaAsset['kind']};
export function referenceIssue(model:Model,sources:Reference[],requireMinimum=false):string{
  if(sources.some(item=>item.kind==='source_document'))return 'Эта модель не поддерживает документы в качестве референсов.';
  const images=sources.filter(item=>item.kind.includes('image')||item.kind==='final_frame').length;
  const videos=sources.filter(item=>item.kind.includes('video')).length;
  const audio=sources.filter(item=>item.kind.includes('audio')).length;
  if(images&&!model.inputModes.includes('image'))return 'Эта модель не поддерживает изображения. Уберите вложения или выберите другую модель.';
  if(videos&&!model.inputModes.includes('video'))return 'Эта модель не поддерживает видео. Уберите вложения или выберите другую модель.';
  if(audio&&!model.inputModes.includes('audio')&&model.id!=='wan/speech-to-video')return 'Эта модель не поддерживает аудиореференс. Уберите вложение или выберите другую модель.';
  const cap=model.referenceCapabilities;
  if(images>(cap?.maxImages??1))return `Лимит модели — ${cap?.maxImages??1} изображений. Уберите лишние вложения.`;
  if(videos>(cap?.maxVideos??1))return `Лимит модели — ${cap?.maxVideos??1} видео. Уберите лишние вложения.`;
  if(audio>1)return 'Лимит модели — один аудиофайл.';
  if(cap?.weightedLimit&&images+videos*(cap.videoWeight??1)>cap.weightedLimit)return 'Превышен общий лимит референсов модели. Уберите часть вложений.';
  if(requireMinimum){
    const minimum=cap?.minImages??(model.inputModes.includes('image')&&!model.inputModes.includes('text')&&!model.inputModes.includes('video')?1:0);
    if(images<minimum)return `Добавьте исходное изображение (минимум ${minimum}).`;
    if(model.id==='wan/speech-to-video'&&!audio)return 'Добавьте аудиофайл с речью.';
  }
  return '';
}
